const STORAGE_KEY = 'app'

// save to local cache storage
export const toCache = (key, val, storage = STORAGE_KEY) => {
  localStorage.setItem(`${storage}/${key}`, JSON.stringify(val))
}

// read from local cache storage
export const fromCache = (key, def, storage = STORAGE_KEY) => {
  const jval = localStorage.getItem(`${storage}/${key}`)
  if (!jval || typeof jval !== 'string') return def
  try {
    const val = JSON.parse(jval)
    return val
  } catch (err) {
    return def
  }
}

// remove from local cache storage
export const delCache = (key, storage = STORAGE_KEY) => {
  localStorage.removeItem(`${storage}/${key}`)
}

export const fromStorage = fromCache
export const toStorage = toCache

// save to local session storage
export const toSession = (key, val, storage = STORAGE_KEY) => {
  sessionStorage.setItem(`${storage}/${key}`, JSON.stringify(val))
}

// read from local session storage
export const fromSession = (key, def, storage = STORAGE_KEY) => {
  const jval = sessionStorage.getItem(`${storage}/${key}`)
  if (!jval || typeof jval !== 'string' || jval === 'undefined') return def
  try {
    const val = JSON.parse(jval)
    return val
  } catch (err) {
    return def
  }
}

// remove from local session storage
export const delSession = (key, storage = STORAGE_KEY) => {
  sessionStorage.removeItem(`${storage}/${key}`)
}

export const getStorage = storage => ({
  toCache: (key, val) => toCache(key, val, storage),
  fromCache: (key, def) => fromCache(key, def, storage),
  delCache: (key) => delCache(key, storage),
  toSession: (key, val) => toSession(key, val, storage),
  fromSession: (key, def) => fromSession(key, def, storage),
  delSession: (key) => delSession(key, storage),
})
